module.exports = __webpack_public_path__ + "assets/fonts/uu5-glyphicons.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/uu5-glyphicons.ttf?n7r5pz
// module id = 339
// module chunks = 0